import Vue from 'vue';
import Vuetify from 'vuetify/lib';

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: '#ff6422',
        secondary: '#7a5d80',
        accent: '#3ea2fb',
        error: '#dc3545',
        petrol: '#17a499',
        background: '#fafafa',
        navbar: '#434343',
        managementNavbar: '#212121'
      },
      dark: {
        primary: '#6b0238',
        secondary: '#3a3e42',
        accent: '#2d75b5',
        error: '#801e27',
        petrol: '#0a4a45',
        background: '#333333',
        navbar: '#434343',
        managementNavbar: '#212121'
      }
    },
    options: {
      customProperties: true
    },
  },
});
